module.exports = __webpack_public_path__ + "img/reaction.1cfa8c08.svg";